import React from 'react'
import { LinkToPost, CardHeaderFaqs } from '../components/'
import { Box, Skeleton, Text } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { useArticles } from '../context/ArticlesContext'
import { buildHelpUri } from '../utilities/buildUri'
import { HelpLinkArticleLoader } from '@/education/shared/components/loaders/HelpLinkArticleLoader'

export const FaqsCategory = () => {
  const navigate = useNavigate()
  const { categorySlug } = useParams()

  const { categories } = useArticles()
  const { data: categoriesData, isLoading } = categories || {}

  const category =
    categoriesData && categoriesData.find(cat => cat.slug === categorySlug)

  const articles = category?.articles
    ? [...category.articles].sort((a, b) => {
        return (
          new Date(a?.createdAt ?? 0).getTime() -
          new Date(b?.createdAt ?? 0).getTime()
        )
      })
    : []

  const isValidArticles = Array.isArray(articles) && !!articles.length

  const handleNavigateToArticle = (slugArticle: string) => {
    if (!slugArticle) return null

    const articleUri = buildHelpUri(slugArticle)['article']
    return navigate(articleUri)
  }

  return (
    <>
      <Skeleton
        isLoaded={!isLoading}
        width={isLoading ? '450px' : '100%'}
        ml={isLoading ? 5 : 0}
        alignSelf={'flex-start'}
        height='78.11px'
      >
        {category && (
          <CardHeaderFaqs
            name={category.name}
            body={category.description}
            image={category.urlImage}
          />
        )}
      </Skeleton>
      <Box
        display={'flex'}
        flexDirection={'column'}
        width={'100%'}
        padding={'15px'}
        borderRadius={'8px'}
        gap={'10px'}
        bg={'#171717'}
      >
        {isLoading && <HelpLinkArticleLoader />}
        {!isLoading &&
          isValidArticles &&
          articles.map(article => (
            <LinkToPost
              key={article.id}
              name={article.title}
              slug={article.slug}
              onClick={handleNavigateToArticle}
            />
          ))}
        {!isLoading && !isValidArticles && (
          <Text
            fontSize={'20px'}
            fontWeight={500}
            color={'#a2a2a2'}
            textAlign={'center'}
            p={'10px 20px'}
          >
            No hay artículos disponibles
          </Text>
        )}
      </Box>
    </>
  )
}
